import http from "../httpServices";

/**\
 * @return A list of emails of users subscribed to the newsletter
 */
export const newsLetters = () => {
  return http.get("admin/newsLetters");
};
